<template>
    <transition name="slide-fade">
        <div class="modal" atm="confirm-modal" data-cy="modal_confirm_redeem" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-sm">
                    <img class="fixed left-0 right-0 w-40 h-48 mx-auto -mt-20" :src="initImageUrls()">
                    <div class="pt-28 pb-4 text-center">
                        <BuyConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'buy'" />
                        <DefaultConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'default' || type == 'delivery'" />
                        <!-- <DeliveryConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'delivery'" /> -->
                        <DrawConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'draw'" />
                        <InterfaceConfirmRedeem
                            :campaign="campaign"
                            v-if="type == 'interface'" />
                    </div>
                    <div class="grid grid-cols-2 gap-2 w-full px-5 pb-5">
                        <div>
                            <button atm="cancel-button" class="w-full btn bg-a-white-ffffff border border-a-blue-2140a6 font-bold text-a-blue-2140a6 text-18 rounded-sm py-1" data-cy="btn_confirm_redeem_cancel" @click="clickCancel()">
                                {{btnCancel}}
                            </button>
                        </div>
                        <div>
                            <button atm="confirm-button" class="w-full btn bg-a-blue-2140a6 text-a-white-ffffff font-bold text-18 rounded-sm py-1 " data-cy="btn_confirm_redeem_ok" @click="clickOk()">
                                {{btnOk}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";
//component
import BuyConfirmRedeem from './component/BuyConfirmRedeem.vue';
import DefaultConfirmRedeem from './component/DefaultConfirmRedeem.vue';
// import DeliveryConfirmRedeem from './component/DeliveryConfirmRedeem.vue';
import DrawConfirmRedeem from './component/DrawConfirmRedeem.vue';
import InterfaceConfirmRedeem from './component/InterfaceConfirmRedeem.vue';
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "ConfirmRedeemModal",
    mixins: [LocaleMixin],
    components: {
        BuyConfirmRedeem,
        DefaultConfirmRedeem,
        // DeliveryConfirmRedeem,
        DrawConfirmRedeem,
        InterfaceConfirmRedeem,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.confirm_redeem.cancel;
            }

            this.controller.sendCallbackShow();

            this.initialModal();
            document.body.classList.add('not-scroll');
            this.open = true;

        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },

        initialModal: function () {
            if (!this.campaign.delivered) {
                switch (this.campaign.type) {
                    case CampaignType.Buy:
                        this.type = 'buy';
                        break;
                    case CampaignType.Draw:
                        this.type = 'draw';
                        break;
                    case CampaignType.Interface:
                        this.type = 'interface';
                        break;
                    case CampaignType.Free:
                    case CampaignType.Deal:
                        this.type = 'default';
                        break;
                }
            } else {
                this.type = 'delivery';
            }
            console.log(this.type);
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // images loading
            return baseUrl + 'image/modalconfirm/img-fish-confirm.png';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 20px;
            }
        }
        .btn {
            height: 50px;
        }
    }

</style>
